import { render, staticRenderFns } from "./DataSingleDocumentRegister.vue?vue&type=template&id=d80c230c&"
import script from "./DataSingleDocumentRegister.vue?vue&type=script&lang=js&"
export * from "./DataSingleDocumentRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports